<mat-form-field appearance="outline">
  <mat-label>
    &nbsp;&nbsp;&nbsp;{{ 'turbo.core.RentalDialog.txtCellular' | translate : 'Mobile phone'}}
  </mat-label>
  <input autocomplete="off"
         type="tel"
         matInput
         placeholder="{{ country.phonePlaceholder }}"
         [formControl]="control"
         (keydown.space)="$event.preventDefault();"
         (change)="onChange($event.target.value)"
         (focus)="onFocus()"
         (blur)="onBlur()">
  <mat-select matPrefix class="country-code-select" [(value)]="country" (selectionChange)="changePrefix()">
    <mat-select-trigger>
      <img width="32" height="32" src="{{ country.flagPath }}">
    </mat-select-trigger>
    <mat-option *ngFor="let c of countries" [value]="c">
      <img width="32" height="32" src="{{ c.flagPath }}">
      {{ 'Intellitrailer.MyPage.ValidateAccount.' + c.fullName | translate : c.fullName }} ({{ c.phonePrefix }})
    </mat-option>
  </mat-select>
  @if(control.hasError('required')) { <mat-error>{{ errors?.required }}</mat-error> }
  @if(control.hasError('minLength')) { <mat-error>{{ errors?.minLength }}</mat-error> }
  @if(control.hasError('pattern')) { <mat-error>{{ errors?.pattern }}</mat-error> }
</mat-form-field>
